// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__z0ZdG","cell":"ColumnAccessor_cell__2wCxu","firstCellAccent":"ColumnAccessor_firstCellAccent__8A_9W"};